import React from 'react'
import { ComponentData } from '../data/ComponentContext'
import { Col, Row } from 'react-bootstrap'

function ColorCheckbox({ className, displayErrors }) {

  const { Colors, selectedColors, addToSelectedColors, removeFromSelectedColors, colorsAreValid } = ComponentData()

  return (
    <Col md={12}>
      <div className={className}>
        <Row className="headline_texts">
          <div className="configuration-text">
            <p>Definiert Aufheizgeschwindigkeit bei IR</p>
            <h3>Farbe</h3>
          </div>
        </Row>
        <div className={displayErrors && !colorsAreValid ? "color-select error" : 'color-select'}>
          {Colors.map((color) => {
            return (
              <label className='color-lable' key={'color-cb-' + color}>
                <input
                  type="checkbox"
                  name='color'
                  className={'checkbox-color ' + color}
                  checked={selectedColors.includes(color)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      if (selectedColors.length >= 3) {
                        e.target.checked = false;
                      } else {
                        addToSelectedColors(color)
                      }
                    } else {
                      removeFromSelectedColors(color)
                    }
                  }}
                />
                <div className='color-div'>
                </div>
              </label>
            )
          })}
          {displayErrors && !colorsAreValid ? <p className='error'>Mindestens eine Farbe muss gewählt werden!</p> : null}
        </div>
      </div>
    </Col>
  )
}

export default ColorCheckbox